<!-- MÓDULO FILTROS EDITABLE -->
<div class="module filtros">
  <h2>{{ "financial-setup.form.filter" | translate }}</h2>
  <form action="" [formGroup]="form">
    <div class="wrapperG4">
      @for (option of optionsProductType; track option) {
      <div>
        <h3>{{ option.filterType.name }}</h3>
        @for (filter of option.filterType.filter; track filter) {
        @if ("DEALER_TYPE" === option.filterType.type) {
        <div class="acciones">
          <label class="radioWrapper">
            @if (filter.value === DealerType.DEALER_FULL) {
            <span class="description">{{ filter.description }} </span>
            } @else {
            <span class="description">{{ filter.description + " " + showTotalByDealer() }} </span>
            }
            <input type="radio"
            formControlName="{{ filter.formControlName }}"
            name="distribuidores"
            value="{{ filter.value }}"
            (change)="onDealerTypeChange($event, filter.formControlName, filter.value)"
            />
            <span class="checkmark"></span>
          </label>
          <a (click)="openDealerModal(filter)" *ngIf="filter.edit" tp="Seleccionar {{filter.description}}"
            class="edit">Seleccionar distribuidores</a>
        </div>


        } @else {
        <div class="acciones">
          <label class="checkboxWrapper">
            @if ('PRODUCT_TYPE' === option.filterType.type) {
              <input
              [checked]="filter.partial === true || filter.partial === false"
              type="checkbox"
              formControlName="{{filter.formControlName}}"
              value="{{ filter.value }}"
              (change)="
                onProductTypeChange(
                  $event,
                  filter.formControlName,
                  filter.value,
                  option.filterType.type || ''
                )
              "
                />
              <span class="checkmark" [ngClass]="{'undefined': filter.partial === true, 'completed': filter.partial === false }"></span>
              @if(filter.partial === false){
                <span class="description">{{ filter.description + " (Todos)" }}</span>
              }@else if(filter.partial === true ) {
                <span class="description">{{ filter.description + " " + showTotalByType(filter) }}</span>
              }@else{
                <span class="description">{{ filter.description }}</span>
              }


            } @else {
              <input
                    [checked]="filter.isChecked"
                    type="checkbox"
                    formControlName="{{ filter.formControlName }}"
                    value="{{ filter.value }}"
                    (change)="
                onTypeChange(
                  $event,
                  filter.formControlName,
                  filter.value,
                  option.filterType.type || ''
                )
              "
                  />
              <span class="checkmark"></span>
              <span class="description">{{ filter.description }} </span>
            }
          </label>
          <a *ngIf="filter.edit" (click)="openModalFilter(filter)" tp="Seleccionar {{filter.description}}"
            class="edit">Seleccionar {{ filter.description }}</a>
          <!-- <a *ngIf="filter.edit && this.form.controls[filter.formControlName].value" (click)="openModalFilter(filter)"
                    tp="Seleccionar {{filter.description}}" class="edit">Seleccionar {{ filter.description }}</a>-->
        </div>
        }
        }
      </div>
      }
    </div>
  </form>
</div>
<ng-template #modalTemplate>
  <app-model-template
  [financialSetupModels]="financialSetupModels"
  [classification]="classification"
  [modelType]="this.modelType"
  (modelSelectedEmit)="modelSelected($event)"
  [filterModels]="this.filterModels"
  ></app-model-template>
</ng-template>
<ng-template #dealerTemplate>
  <app-dealer-template [dealerIds]="dealerIds" (dealerSelectedEmit)="dealerSelected($event)"></app-dealer-template>
</ng-template>
